import { store } from '../store';
import { Utilities } from '../helpers';
import { passwordApi } from '@sendent/nextcloud-api';

const validatePassword = async (password: string | undefined) => {
    const state = store.getState();

    if (
        !state.authentication.filesSharingSettings?.PasswordEnabled &&
        Utilities.isStringEmpty(password)
    ) {
        return '';
    }

    const user = state.authentication.user;
    if (!user) {
        return '';
    }

    const passwordValidateResult = await passwordApi.validatePassword(
        state.appReducer.appConfig.stubUrl,
        user,
        password ?? '',
    );
    if (
        passwordValidateResult.success === true &&
        passwordValidateResult.result.ocs.data.passed === true
    ) {
        return '';
    } else {
        return passwordValidateResult.result.ocs.data.reason;
    }
};

const validateDate = async (_date: unknown) => {
    return '';
};

const canSkip = (
    id: string,
    data: { password?: string; date?: Date | string | null },
) => {
    switch (id) {
        case 'password':
            return Utilities.isStringEmpty(data.password) ? false : true;
        case 'date':
            return Utilities.isNANObject(data.date) || data.date === ''
                ? false
                : true;
    }
    return false;
};

export const validationApi = {
    validatePassword,
    validateDate,
    canSkip,
};
